import { useMemo } from 'react';
import { shallowEqual } from 'react-redux';

import { useSelector } from '../../selectors/useSelector';

import SelectPropertyConstants from '../../constants/SelectPropertyConstants';
import { VERTICAL_DISPLAY_TYPE } from '../../constants/PropertiesConstants';

import selectPropertyUtils from '../../utils/selectPropertyUtils';

import ConnectedModuleCard from '../../components/ConnectedModuleCard';
import ConnectedLeasesModule from '../ConnectedLeasesModule';

import { StyledNoUnderlineAnchor } from '../../StyledComponents/StyledComponents';
import PropertiesPageCSEvents from '../../model/ClickstreamEvent/PropertiesPageCSEvents';

const LeasesModule = () => {
  const { listingAlias, user } = useSelector(
    (state) => ({ user: state.user, listingAlias: state.properties.currentProperty.listingAlias }),
    shallowEqual,
  );

  const leasesPath = selectPropertyUtils.getPathByType(
    SelectPropertyConstants.LEASES as keyof typeof SelectPropertyConstants,
    listingAlias,
  );

  function onDetailsClick() {
    PropertiesPageCSEvents.LeasesCardDetailsClick({
      user,
    });
    window.location.href = leasesPath || '';
  }

  const renderCTA = useMemo(() => {
    return (
      <StyledNoUnderlineAnchor
        onClick={onDetailsClick}
        data-eventid={PropertiesPageCSEvents.LeasesCardDetailsClick.data_event_id}
      >
        Details
      </StyledNoUnderlineAnchor>
    );
  }, [leasesPath]);

  return (
    <ConnectedModuleCard
      data-testid="LeasesModule"
      title="Leases"
      ctaComponent={renderCTA}
      ctaFontColor="text.subtle"
      ctaFontType="body-sm"
      justifyHeadingContent={'center'}
      isLoading={false}
    >
      <ConnectedLeasesModule displayType={VERTICAL_DISPLAY_TYPE.SIMPLE} />
    </ConnectedModuleCard>
  );
};

export default LeasesModule;
